import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import api from '../../services/api';

import AnimationContainer from '../FadeAnimation';
import Headline from '../Headline';
import Form from './Form';
import SuccessMessage from './SuccessMessage';
// import Analytics from '../../services/Analytics';

class FormContainer extends Component {
    constructor() {
        super();
        this.state = {
            isSend: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(data) {
        const { scrollTo } = this.props;
        api.createRequest(data)
            .then(() => {
                this.setState({ isSend: true });
                // eslint-disable-next-line
                dataLayer.push({'event': 'form_submit'});
                // // eslint-disable-next-line
                // ym(67031677, 'reachGoal', 'form_submit');
                // // eslint-disable-next-line
                // gtag('event', 'form_submit', { 'formURL': window.location.href });
                // Analytics.sendEvent(`submit Form from page: ${window.location.href}`);
                // // eslint-disable-next-line
                // fbq('trackCustom', 'form_submit', { 'formURL': window.location.href });
            });
        scrollTo();
    }

    render() {
        const {
            className,
            checkboxes = [],
            serviceType = 'задачу',
            rootRef,
        } = this.props;
        const { isSend } = this.state;

        return (
            <Root className={className} ref={rootRef}>
                <Wrapper>
                    <AnimationContainer external="parent">
                        <HeadlineStyled>
                            Обсудить
                            {' '}
                            {serviceType}
                        </HeadlineStyled>
                    </AnimationContainer>
                    {
                        !isSend && (
                            <AnimationContainer external="parent" delay={150}>
                                <Form checkboxes={checkboxes} onClick={this.onSubmit} />
                            </AnimationContainer>
                        )
                    }
                    {
                        isSend && (
                            <SuccessMessageStyled />
                        )
                    }
                </Wrapper>
            </Root>
        );
    }
}

const Root = styled.div`
    background: transparent;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const Wrapper = styled.div`
    min-width: 328px;

    ${mediaWidth.m} {
        min-width: 100%;
    }
`;

const HeadlineStyled = styled(Headline)`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 32px;
    line-height: 32px;

    text-transform: uppercase;

    ${mediaWidth.m} {
        font-size: 48px;
        line-height: 48px;
    }

    ${mediaWidth.l} {
        font-size: 32px;
        line-height: 32px;
    }
`;

const SuccessMessageStyled = styled(SuccessMessage)`
    display: block;

    width: 100%;
    height: 100%;

    padding-top: 118px;

    ${mediaWidth.m} {
        width: 304px;
    }

    ${mediaWidth.xl} {
        width: 409px;
    }
`;

export default FormContainer;
